export const getFeatureFlags = () => ({});

export const getbreadCrumbSteps = localization => {
  const breadcrumbSteps = [
    [
      {
        name: localization && localization.patients,
        pathname: '/',
      },
      {
        name: localization && localization.backPatients,
        pathname: '/patientprofile',
        fallBack: '/',
        enableBackLink: true,
      },
      {
        name: localization && localization.createEPresc,
        pathname: '/createprescription',
        isViewTitle: true,
      },
      {
        name: localization && localization.editEPresc,
        pathname: '/editprescription',
        isViewTitle: true,
      },
    ],
  ];

  const breadcrumbProps = {
    stepsArray: breadcrumbSteps,
    validationElementName: '#user-form',
  };

  return breadcrumbProps;
};

export const isSupportSingleLanguage = (user, isUserLoaded) => {
  // Get user token
  if (isUserLoaded) {
    // eslint-disable-next-line prefer-destructuring
    const countriesSupportSingleLanguage = window.countriesSupportSingleLanguage;
    return countriesSupportSingleLanguage.includes(user.CountryId);
  }
  return true;
};
